<template>
  <div class="indexBody">
    <!-- 第一行 -->
    <el-row class="row1">
      <div class="userInfo">
        <div class="user_row1">
          <div class="imgbox">
            <img v-if="avatarUrl" :src="avatarUrl" alt />
            <img
              class="header"
              v-else
              src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
              alt
            />
          </div>
          <div class="infobox">
            <h3
              class="unsername"
              v-if="indexInfoData.memberinfo"
            >{{indexInfoData.memberinfo.nickname}}</h3>
            <p>
              <!-- 安评部 -->
              <span
                class="ovflowHi"
                style="margin-right:5px;width:55px"
                v-if="indexInfoData.department_name"
              >{{indexInfoData.department_name}}</span>
              <!-- 主管/评价人员 -->
              <span class="ovflowHi" style="width:120px" :title="callsTitle">
                <span>{{callsTitle}}</span>
              </span>
            </p>
            <p>
              部门成员
              <span @click="goClassPage" class="Number">{{indexInfoData.mc_count}}</span> 人
            </p>
            <p>
              我参与的项目
              <span
                @click="goProjectList('participate')"
                class="Number"
                v-if="indexInfoData.count_list"
              >{{indexInfoData.count_list[2]}}</span> 个
            </p>
          </div>
        </div>
        <div class="user_row2">
          <h3>座右铭</h3>
          <span v-if="indexInfoData.memberinfo">{{indexInfoData.memberinfo.motto}}</span>
        </div>
      </div>
      <div class="userNumber">
        <ul class="usernumItem">
          <!-- 正在进行的项目 -->
          <li @click="goProjectList('ongoing')">
            <div class="colorDiv" style="background-color: #30ad5f;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_jxxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#30AD5F;"
              >{{indexInfoData.count_list[0]}}</div>
              <span title="正在进行的项目">正在进行的项目</span>
            </div>
          </li>
          <!-- 我的待办项目 -->
          <li @click="goWait">
            <div class="colorDiv" style="background-color: #0EA3E8;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_dbxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#0EA3E8;"
              >{{indexInfoData.count_list[1]}}</div>
              <span title="我的待办项目">我的待办项目</span>
            </div>
          </li>
          <!-- 我参与的项目 -->
          <li @click="goProjectList('participate')">
            <div class="colorDiv" style="background-color: #CE73DC;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_cyxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#CE73DC;"
              >{{indexInfoData.count_list[2]}}</div>
              <span title="我参与的项目">我参与的项目</span>
            </div>
          </li>
          <!-- 我负责的项目 -->
          <li @click="goProjectList('responsible')">
            <div class="colorDiv" style="background-color: #F55F5F;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_fzxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#F55F5F;"
              >{{indexInfoData.count_list[3]}}</div>
              <span title="我负责的项目">我负责的项目</span>
            </div>
          </li>
          <!-- 我关注的项目 -->
          <li @click="goProjectList('attention')">
            <div class="colorDiv" style="background-color: #F09C0A;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_gzxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#F09C0A;"
              >{{indexInfoData.count_list[4]}}</div>
              <span title="我关注的项目">我关注的项目</span>
            </div>
          </li>
          <!-- 已归档项目 -->
          <li @click="goProjectList('guidang')">
            <div class="colorDiv" style="background-color: #28CEBC;">
              <div class="hideDiv"></div>
            </div>
            <div class="li_left">
              <img src="../../assets/image/icon_gdxm@2x.png" alt />
            </div>
            <div class="li_right">
              <div
                class="number"
                v-if="indexInfoData.count_list"
                style="color:#28CEBC;"
              >{{indexInfoData.count_list[5]}}</div>
              <span title="已归档项目">已归档项目</span>
            </div>
          </li>
        </ul>
      </div>
    </el-row>
    <!-- 第二行 -->
    <el-row class="row2">
      <!-- 项目 -->
      <div class="project">
        <h3 class="title">项目</h3>
        <div class="projectBox">
          <!-- 主体------列表 -->
          <ul
            class="projectList"
            v-if="indexInfoData.project_list && indexInfoData.project_list.length>0"
          >
            <li
              @click="goProjectIndex(item)"
              v-if="indexInfoData"
              v-for="item in indexInfoData.project_list"
              :key="item.project_id"
            >
              <div class="projectLi_left">
                <h3 class="overFlowerHiddenTitle" :title="item.project_name">{{item.project_name}}</h3>
                <p class="indexProjectContainer">
                  <span class="span_title">企业名称：</span>
                  <span
                    class="overFlowerHiddenBox"
                    :title="item.company_name"
                    style="margin-right:30px"
                  >{{item.company_name}}</span>
                  <span class="span_title">当前阶段：</span>
                  <span
                    class="overFlowerHiddenBox"
                    :title="item.project_status_show"
                  >{{item.project_status_show}}</span>
                </p>
                <p class="indexProjectContainer">
                  <span class="span_title">项目类型：</span>
                  <span
                    class="overFlowerHiddenBox"
                    :title="item.pte_show"
                    style="margin-right:30px"
                  >{{item.pte_show}}</span>
                  <span class="span_title">项目登记人：</span>
                  <span
                    class="overFlowerHiddenBox"
                    :title="item.memberInfo.nickname"
                    v-if="item.memberInfo"
                    style="margin-right:30px"
                  >{{item.memberInfo.nickname}}</span>
                  <span class="span_title">项目主办：</span>
                  <span
                    class="overFlowerHiddenBox"
                    :title="item.evaluatorsInfo.nickname"
                    v-if="item.evaluatorsInfo"
                  >{{item.evaluatorsInfo.nickname}}</span>
                </p>
              </div>
              <div
                v-if="item.approval_show"
                class="projectLi_right"
              >{{item.approval_show.update_time}}</div>
            </li>
          </ul>
          <div v-else>
            <p style="color:#909399;text-align:center;padding-top:8vh">暂无数据</p>
          </div>
        </div>
      </div>
      <!-- 系统公告 -->
      <div class="messages">
        <div class="title">
          <h3>系统公告</h3>
          <span @click="checkMoreNotice">查看更多</span>
        </div>
        <ul
          class="messagesBox"
          v-if="indexInfoData.notice_list && indexInfoData.notice_list.length>0"
        >
          <li
            @click="checkMessage(item)"
            v-if="indexInfoData.notice_list"
            v-for="item in indexInfoData.notice_list"
            :key="item.id"
          >
            <span class="hidden">{{item.title}}</span>
          </li>
        </ul>
        <div v-else>
          <p style="color:#909399;text-align:center;padding-top:8vh">暂无数据</p>
        </div>
      </div>
    </el-row>
    <!-- 系统公告弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      class="systemVoice"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">系统公告</span>
      </div>
      <div class="diaContainer messageBody ruleHeight">
        <h1>{{messageInfo.title}}</h1>
        <p class="username">{{'发布:'+messageInfo.membername}}</p>
        <!-- <p class="content">{{messageInfo.content}}</p> -->
        <div class="ql-container ql-snow" style="margin:20px 0">
          <div class="ql-editor" v-html="messageInfo.content"></div>
        </div>
      </div>
    </el-dialog>
    <!-- 新入职填写信息弹窗 -->
    <el-dialog
      :visible.sync="entryDia"
      width="60%"
      :before-close="handleEntryClose"
      class="entryDia"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">入职资料填写</span>
      </div>
      <div class="diaContainer messageBody ruleHeight">
        <el-form class="entryForm" :model="entryForm" label-position="left" label-width="160px">
          <!-- 项目名称 -->
          <div style="box-sizing:border-box;padding:0 10%">
            <div class="diaForm_box">
              <el-form-item label="真实姓名">
                <el-input placeholder="请输入您的真实姓名" v-model="entryForm.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号">
                <el-input type="number" placeholder="请输入您的身份证号" v-model="entryForm.id_number"></el-input>
              </el-form-item>
              <el-form-item label="银行卡号">
                <el-input type="number" placeholder="请输入您的银行卡号" v-model="entryForm.bank_number"></el-input>
              </el-form-item>
              <el-form-item label="身份证人像面">
                <upload-imgone style="width:100%" @my-upload-change="upLoadChange1"></upload-imgone>
              </el-form-item>
              <el-form-item label="身份证国徽面">
                <upload-imgone style="width:100%" @my-upload-change="upLoadChange2"></upload-imgone>
              </el-form-item>
              <el-form-item label="毕业证书/学位证书">
                <upload-imgone style="width:100%" @my-upload-change="upLoadChange3"></upload-imgone>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleEntrySubmitClick('0')">提 交</el-button>
        <el-button style="background-color: #ccc;">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadImg from '../../components/UploadImg'
import UploadImgone from '../../components/UploadImgone'
export default {
  data() {
    return {
      // 判断是否新入职
      entryDia: false,
      // 入职信息
      entryForm: {
        name: '',
        id_number: '',
        bank_number: '',
        id_card_url: '',
        id_card_url2: '',
        diploma_url: '',
      },
      // 身份证人面
      imgList1: [],
      // 身份证国徽
      imgList2: [],
      // 学位证书
      imgList3: [],
      value: '123',
      cache_department_id: '',
      cache_department_id_store: '',
      dialogVisible: false,
      projectSearchInfo: '',
      projectStatus: '1',
      token: '',
      company_id: '',
      indexInfoData: {},
      avatarUrl: '',
      callsTitle: '',
      messageInfo: {},
    }
  },
  methods: {
    // 入职材料填写
    async handleEntrySubmitClick() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }

      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('name', this.entryForm.name)
      param.append('id_number', this.entryForm.id_number)
      param.append('bank_number', this.entryForm.bank_number)
      param.append('id_card_url', this.entryForm.id_card_url)
      param.append('id_card_url2', this.entryForm.id_card_url2)
      param.append('diploma_url', this.entryForm.diploma_url)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Index/entry',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.entryDia = false
    },
    // 上传人像面
    upLoadChange1(data) {
      console.log('data', data)
      this.entryForm.id_card_url = data
    },
    // 上传国徽面
    upLoadChange2(data) {
      this.entryForm.id_card_url2 = data
    },
    // 上传学位证
    upLoadChange3(data) {
      this.entryForm.diploma_url = data
    },
    // /admin/organization?type=1
    goClassPage() {
      this.$router.push({
        path: '/admin/organization',
        query: {
          type: '1',
        },
      })
    },
    // 点击单条系统公告
    checkMessage(item) {
      this.$store.commit('process/message/setMessageDetails', item)
      this.$router.push({
        name: 'messageDetails',
      })

      // this.messageInfo = item
      // this.dialogVisible = true
    },
    // 点击我的待办项目
    async goWait() {
      this.$router.push('/myFlow')
    },
    goProjectList(val) {
      if (val == 'attention') {
        return this.$router.push({
          path: '/project/attention',
        })
      }
      if (val == 'guidang') {
        return this.$router.push({
          path: '/project/save',
        })
      }
      this.$router.push({
        path: '/project/index',
        query: {
          type: val,
        },
      })
    },
    checkMoreNotice() {
      this.$router.push({
        path: '/admin/organization',
        query: {
          type: '3',
        },
      })
    },
    // 点击单条项目
    goProjectIndex(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          project_name: item.project_name,
          project_code: item.project_code,
          company_name: item.company_name,
          isEdit: '1',
          fromIndex: '1',
        },
      })
    },
    // *获取首页信息
    async getIndexInfo() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Index/overview',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.indexInfoData = res.datas
      this.avatarUrl = res.datas.memberinfo.avatar
      if (this.indexInfoData.call.length > 0) {
        this.callsTitle = this.indexInfoData.call.join('/')
      }
      // 判断需要填写入职信息
      if (this.indexInfoData.is_entry == '0') {
        this.entryDia = true
      }
      console.log('首页获取到的首页信息', this.indexInfoData)
    },

    // 点击搜索图标
    handleProjectSearch() {},
    projectStatusChange(val) {
      this.projectStatus = val
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleEntryClose(done) {
      this.entryDia = false
    },
  },
  components: {
    UploadImgone,
    UploadImg,
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.getIndexInfo()
  },
}
</script>
<style lang="less" scoped>
#indexPage {
  width: 100%;
  height: 100%;
  background-color: #f2f3f4;
  .indexBody {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 3.6%;
    height: 92%;
    // 第一大行
    .row1 {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      .userInfo {
        width: 30%;
        height: 300px;
        border-radius: 10px;
        background-color: #fff;
        margin-right: 30px;
        box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
        padding: 0 40px;
        .user_row1 {
          height: 62%;
          border-bottom: 1px solid#EBEBEB;
          display: flex;
          // align-items: center;
          // 左边头像
          .imgbox {
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 106px;
              height: 106px;
              border-radius: 53px;
            }
          }
          // 右边信息
          .infobox {
            .unsername {
              color: #333333;
              font-weight: normal;
              font-size: 22px;
              margin: 18% 0 15px;
              width: 160px;
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
            }
            .ovflowHi {
              display: inline-block;
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
            }
            p {
              font-size: 16px;
              color: #666;
              margin-bottom: 8px;
              .Number {
                color: #128bf1;
                cursor: pointer;
              }
            }
          }
        }
        .user_row2 {
          height: 38%;
          h3 {
            font-size: 18px;
            color: #666;
            font-weight: normal;
            margin-top: 5%;
          }
          span {
            display: block;
            width: 100%;
            color: #999999;
            font-size: 16px;
            margin-top: 10px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
          }
        }
      }
      .userNumber {
        width: calc(70% - 30px);
        height: 300px;
        .usernumItem {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          li {
            cursor: pointer;
            width: 32%;
            overflow: hidden;
            height: 47%;
            border-radius: 10px;
            margin-right: 2%;
            position: relative;
            display: flex;
            background-color: #fff;
            box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
            .li_left {
              box-sizing: border-box;
              width: 40%;
              height: 100%;
              padding-left: 5%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 62px;
                height: 62px;
              }
            }
            .li_right {
              box-sizing: border-box;
              width: 60%;
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding-right: 5%;
              .number {
                font-size: 36px;
                // font-weight: bold;
                margin-top: 10%;
                margin-bottom: 5%;
              }
              span {
                display: block;
                text-align: center;
                width: 100%;
                font-size: 20px;
                color: #666;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }
            // 制作li的左边彩色条
            .colorDiv {
              position: absolute;
              width: 1%;
              height: 100%;
              border-radius: 10px;
              .hideDiv {
                position: absolute;
                margin-left: 3.5px;
                width: calc(100% - 3.5px);
                height: 100%;
                background-color: #fff;
              }
            }
            // 制作li的左边彩色条
          }
          li:nth-child(-n + 3) {
            margin-bottom: 1.5%;
          }
          li:nth-child(3),
          li:nth-child(6) {
            margin-right: 0;
          }
        }
      }
    }
    // 第二大行
    .row2 {
      display: flex;
      width: 100%;
      height: calc(100% - 330px);
      // --!!!!项目
      .project {
        box-sizing: border-box;
        height: 100%;
        width: 69%;
        margin-right: 1%;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
        padding: 0 40px;
        .title {
          height: 65px;
          box-sizing: border-box;
          font-weight: normal;
          line-height: 70px;
          font-size: 22px;
          color: #333;
          border-bottom: 1px solid #ebebeb;
        }
        .projectBox {
          width: 100%;
          height: calc(100% - 65px);
          // 头部-----tabs++搜索框
          .headerRow {
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // tab栏ul
            .projectStatus {
              width: 50%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              font-size: 18px;
              margin-left: 20px;
              color: #666;
              li {
                position: relative;
                cursor: pointer;
                .underLine {
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  // width: 30px;
                  width: 80%;
                  height: 3px;
                  background-color: #40a0f2;
                  margin-top: 5px;
                }
              }
            }
            // 右边搜索框和图标盒子
            .rightSearch {
              width: 50%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .sort {
                margin-left: 40px;
                width: 26px;
                height: 24px;
              }
            }
          }
          // 主体------列表
          .projectList {
            // 加15px
            // **(去掉头部后修改为100%)
            // height: calc(100% - 85px);
            height: calc(100%);
            overflow-x: auto;
            // 为了box-shadow;
            padding: 3px;
            li {
              cursor: pointer;
              padding: 0 30px;
              height: 32%;
              min-height: 120px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px solid #ebebeb;
              .projectLi_left {
                width: 70%;
                h3 {
                  font-size: 20px;
                  color: #333;
                }
                p {
                  margin-top: 3%;
                  font-size: 14px;
                  color: #666;
                  .span_title {
                    color: #999;
                  }
                }
              }
            }
            li:hover {
              box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
            }
            li:hover h3 {
              color: #128bf1;
            }
            .projectLi_right {
              color: #999999;
              font-size: 18px;
            }
          }
        }
        // --!!!!系统公告
      }
      .messages {
        width: 30%;
        height: 100%;
        background-color: #fff;
        border-radius: 10px;
        padding: 0 30px;
        box-sizing: border-box;
        box-shadow: 1px 5px 9px 0px rgba(3, 70, 126, 0.14);
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 65px;
          box-sizing: border-box;
          font-weight: normal;
          color: #333;
          border-bottom: 1px solid #ebebeb;
          h3 {
            font-weight: normal;
            font-size: 22px;
            margin-top: 5px;
          }
          span {
            font-size: 16px;
            cursor: pointer;
            color: #cccccc;
          }
        }
        .messagesBox {
          box-sizing: border-box;
          width: 100%;
          padding: 10px 0;
          // height: calc(100% - 65px);
          height: calc(100% - 75px);
          overflow-y: auto;
          li {
            position: relative;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            color: #333;
            font-size: 16px;
            height: 10%;
            min-height: 35px;
            box-sizing: border-box;
            .hidden {
              cursor: pointer;
              margin-left: 15px;
              width: calc(100%-30px);
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
            }
          }
          li::before {
            position: absolute;
            content: '';
            width: 4px;
            height: 4px;
            border: 2px solid #128bf1;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
// 搜索框
// 登录输入框
.loginInput {
  width: 50%;
  min-width: 220px;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  img {
    position: absolute;
    right: 20px;
    cursor: pointer;
    z-index: 2;
    width: 22px;
    height: 22px;
  }
  /deep/.el-input__inner {
    background-color: rgba(255, 255, 255, 0);
    outline: none;
    border-radius: 0;
    border: none;
    background-color: #f4f5f6;
    padding-left: 30px;
    font-size: 16px;
    height: 40px;
    border-radius: 20px;
  }
}
.projectStatusActive {
  color: #333;
}
// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
  .messageBody {
    h1 {
      font-size: 22px;
      color: #333;
      font-weight: normal;
      text-align: center;
    }
    .username {
      color: #666;
      font-size: 18px;
      box-sizing: border-box;
      padding-right: 30px;
      text-align: right;
      margin: 20px 0;
    }
    .content {
      font-size: 16px;
      color: #333;
      height: 400px;
      margin-bottom: 60px;
    }
  }
  // 知识库详情主体内容
  .diaContainer {
    width: 100%;
    box-sizing: border-box;
    padding-left: 40px;
    // 按钮行
    .diaBtnRow {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      .el-button {
        height: 46px;
        padding: 0 40px;
        font-size: 20px;
        font-weight: normal;
        color: #fff;
        border: none;
        border-radius: 25px;
        background-color: #40a0f2;
        margin-bottom: 10px;
      }
      .el-button:first-child {
        margin-right: 2%;
      }
    }
  }
}
.ql-container {
  width: 95%;
  height: initial;
}
.overFlowerHiddenTitle {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.indexProjectContainer {
  display: flex;
  .overFlowerHiddenBox {
    display: block;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.systemVoice {
  /deep/.el-dialog {
    margin-top: 8vh !important;
  }
}
.ruleHeight {
  max-height: 70vh;
  overflow-y: auto;
}

// dialog弹窗
//入职资料填写弹窗样式
.entryDia {
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 45px;
      padding: 0;
      font-size: 18px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 10px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  // img dia 尾部
  .imgFooter {
    padding-left: 0;
    justify-content: center;
    margin-bottom: 20px;
  }

  /deep/.el-form-item {
    margin-bottom: 15px;
  }
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    font-weight: 700;
    box-sizing: border-box;
    // padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      // 修改多选标签大小

      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        // font-size: 18px;
      }
    }
    .el-input__inner {
      // font-size: 14px;
      font-size: inherit;
      width: 100%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 100%;
      .el-textarea__inner {
        height: 80px;
        // font-size: 14px;
        min-height: 80px !important;
        font-size: inherit;
        resize: none;
        border-radius: 0;
        font-family: Microsoft YaHei;
      }
    }
    .el-radio-group {
      height: 35px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      .el-radio {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // margin-right: 15%;
        width: 25%;
      }
      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }
}
</style>